import { render } from "./ChapterResults.vue?vue&type=template&id=4204c5b8"
import script from "./ChapterResults.vue?vue&type=script&lang=js"
export * from "./ChapterResults.vue?vue&type=script&lang=js"

import "./ChapterResults.vue?vue&type=style&index=0&id=4204c5b8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__